import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { Button, Empty, Space, Select } from "antd";

import { Bar } from "@ant-design/charts";

import moment from "moment";
import { chain } from "lodash";
import { ReloadOutlined } from "@ant-design/icons";

import { getTopWeldHoursList } from "../../features/performance/performanceSlice";

import PickerWithType from "../../libs/components/PickerWithType";
import SelectDateType from "../../libs/components/SelectDateType";
import { GetDateRange } from "../../libs/utils";

function TopWeldHours(props) {
  const dispatch = useDispatch();

  const top_weld_hours =
    useSelector((state) => state.performance.top_weld_hours) || [];

  const [dateValues, setDateValues] = useState(null);
  const [selectedValues, setSelectedValues] = useState(null);
  const [type, setType] = useState("range");

  const today = moment();
  const lastWeek = moment().subtract(7, "days");

  useEffect(() => {
    dispatch(
      getTopWeldHoursList(null, {
        start: lastWeek.format("YYYY-MM-DD"),
        end: today.format("YYYY-MM-DD"),
      })
    );
  }, [dispatch]);

  const data =
    !!top_weld_hours && top_weld_hours.length > 0
      ? chain(top_weld_hours)
          .groupBy("id")
          .map((value, index) => ({
            id: index,
            value: value.reduce(
              (prev, curr) =>
                moment.duration(prev).add(moment.duration(curr.value)),
              moment.duration()
            ),
          }))
          .map((item) => ({
            ...item,
            weld_time: moment.duration(item.value).asHours(),
          }))
          .value()
          .sort((a, b) => b.weld_time - a.weld_time)
      : [];

  return (
    <>
      <Space>
        <b>Top Weld Hours</b>

        <SelectDateType value={type} onChange={setType}></SelectDateType>
        <PickerWithType
          type={type}
          defaultValue={[lastWeek, today]}
          onChange={(value) => setDateValues(value)}
        />
        <Button
          disabled={!dateValues}
          onClick={() => {
            const dateRange = GetDateRange(type, dateValues);

            dispatch(
              getTopWeldHoursList(null, {
                start: dateRange[0],
                end: dateRange[1],
              })
            );
          }}
          icon={<ReloadOutlined />}
        ></Button>

        <Select
          style={{ minWidth: 200 }}
          mode="multiple"
          placeholder="Filter by SWR number"
          options={data
            .map((item) => item.id)
            .filter((v, i, a) => a.indexOf(v) === i)
            .map((item) => ({
              label: `SWR-${item === "1" ? 171 : item}`,
              value: item,
            }))}
          onChange={(values) => {
            setSelectedValues(values);
          }}
        ></Select>
      </Space>

      <div>
        {top_weld_hours && top_weld_hours.length > 0 ? (
          <Bar
            {...{
              data:
                !selectedValues || selectedValues.length === 0
                  ? data
                  : data.filter((v, i, a) => {
                      return selectedValues.includes(v.robot_id);
                    }),
              xField: "weld_time",
              yField: "id",
              color: "#1890ff",
              barWidthRatio: 0.9,
              maxBarWidth: 20,
              label: {
                position: "middle",
                formatter: function (v) {
                  return moment
                    .duration(v.value)
                    .asHours()
                    .toFixed(1);
                },
              },
              xAxis: {
                label: {
                  formatter: function formatter(v) {
                    return moment.duration({ hours: v }).asHours().toFixed(1);
                  },
                },
              },
              yAxis: {
                label: {
                  formatter: function formatter(v) {
                    return `SWR-${v === "1" ? 171 : v}`;
                  },
                },
              },
              tooltip: {
                title: (v) => `SWR-${v === "1" ? 171 : v}`,
                formatter: (datum) => {
                  return {
                    name: `SWR-${datum.id === "1" ? 171 : datum.id}`,
                    value:
                      datum.weld_time &&
                      moment
                        .duration({ hours: datum.weld_time })
                        .asHours()
                        .toFixed(1) + " hours",
                  };
                },
              },
            }}
          />
        ) : (
          <Empty />
        )}
      </div>
    </>
  );
}
export default TopWeldHours;
